import React from 'react'

import style from './Messages.module.css'

export default function Messages({ children }) {
  return <section className={style.container}>{children}</section>
}

Messages.layoutElementName = 'Messages'
